import Vue from 'vue'

export default function ({ $config }) {
  Vue.filter('currency', function (value) {
    if (typeof value !== 'number') {
      return value
    }
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    })
    return formatter.format(value)
  })

  Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
  })

  Vue.filter('lowercase', function (value) {
    if (!value) return ''
    return value.toLowerCase()
  })

  Vue.filter('pluralize', (amount, word) =>
    amount > 1 || amount == 0 ? `${word}s` : word
  )

  Vue.filter('absoluteURL', function (value) {
    if (!value) return ''
    return $config.apiUrl + value
  })
}
